import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { getTranslatedString } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    components: {

    },
    props: ['thesaurusTermId'],
    template: require('./thesaurus-term-view.html')
})
export class ThesaurusTermView extends ReactiveVue {

    public thesaurusTermId: string;

    private term: string = "";
    private $thesaurusTermDataStore: ThesaurusTermDataStore;

    private subscribe() {
        const locale = this.getAppLocale();
        this.subscribeTo(
            this.$thesaurusTermDataStore.fetchOne(this.thesaurusTermId),
            thesaurusTerm => {
                this.term = getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), locale)
            },
            'term-subscription')
    }

    @Watch('thesaurusTermId', { immediate: true })
    private onThesaurusTermIdChange() {
        this.unsubscribeFrom('term-subscription');
        if (this.thesaurusTermId) {
            this.subscribe()
        }
    }

}